module.exports = __webpack_public_path__ + "assets/img/Type E (60).7e6d32d4.jpg";